import Vue from 'vue'
import Vuex from 'vuex'
import metrickpi from "@/store/modules/metrickpi";
import historyevents from "@/store/modules/historyevents";
import filecategory from "@/store/modules/file-module/category/filecategory"

Vue.use(Vuex)

export default new Vuex.Store({
                                 modules: {
                                    metrickpi,
                                    historyevents,
                                    filecategory
                                 }
                              })